'use client';
import React from 'react';

import { Text } from '~components/Typography';
import { annals } from '~features/annals/hooks';
import { useModal } from '~hooks/useModal';
import { useTranslations } from '~i18n/hooks';
import GearIcon from '~public/assets/icons/navigation/gear.svg';
import { DropdownElement } from '~shared/ui/atoms';
import { NavigationDrawer } from '~widgets/NavigationDrawer';

export const SettingsItem = () => {
	const t = useTranslations('ProfileMenu');
	const annalsNavSettingsClicked =
		annals.navigation.useNavTopSettingsButtonClicked();

	const { open, isOpen, close } = useModal();

	return (
		<>
			<DropdownElement
				data-name="settings-item"
				icon={<GearIcon />}
				onClick={() => {
					annalsNavSettingsClicked();
					open()();
				}}
			>
				<Text size="M" align="left">
					{t('settingsTitle')}
				</Text>
			</DropdownElement>

			<NavigationDrawer open={isOpen} locked={false} onClose={close} />
		</>
	);
};
